import { render, staticRenderFns } from "./areaStatic.vue?vue&type=template&id=68eed392&scoped=true&"
import script from "./areaStatic.vue?vue&type=script&lang=js&"
export * from "./areaStatic.vue?vue&type=script&lang=js&"
import style0 from "./areaStatic.vue?vue&type=style&index=0&id=68eed392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eed392",
  null
  
)

export default component.exports